import React from "react";
import { useLayout } from "./LayoutProvider";
import { DefaultLayout } from "./DefaultLayout";
import { ClientLayout } from "./ClientLayout";
import actions from "../actions";
import { useDispatch } from "react-redux";
import { ANLoadingScreen } from "@answersnow/pkg-theme";
import { Box } from "@mui/material";

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const { layout, isCheckingPermission } = useLayout();

  const dispatch = useDispatch();
  const content = (
    <>
      {/* Hide content while checking permissions, but show loading screen.
      This prevents a flash of content, but allows the page to set its "menu" and "currentPage"*/}
      <Box sx={{ display: isCheckingPermission ? "none" : "block" }}>{children}</Box>
      {isCheckingPermission && <ANLoadingScreen />}
    </>
  );

  React.useEffect(() => {
    dispatch(actions.checkAuthState());
  }, []);

  // For client layout, we need to pass user data and logout function
  if (layout === "client") {
    return <ClientLayout>{content}</ClientLayout>;
  }

  // For default layout (admin, clinician, etc.)
  return <DefaultLayout>{content}</DefaultLayout>;
};
